var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', {
    attrs: {
      "title": "미팅매칭하기",
      "fullscreen": "",
      "persistent": "",
      "max-width": "1200"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (bind) {
        return [_vm._t("activator", null, null, bind)];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-layout', {
    staticClass: "bottom-sheet__contents h-100",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('meeting-view-tabs', _vm._b({
    scopedSlots: _vm._u([{
      key: "tab-complete-actions",
      fn: function () {
        return [_c('v-btn', {
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function ($event) {
              _vm.shows = false;
            }
          }
        }, [_vm._v("창 닫기")])];
      },
      proxy: true
    }])
  }, 'meeting-view-tabs', {
    meeting: _vm.meeting
  }, false))], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }